import { useEffect } from "react";

/**
 * Preloads critical images for faster LCP
 * @param images Array of image URLs to preload
 * @param priority Whether to use high priority fetch
 */
export const usePreloadImages = (images: string[], priority: boolean = false) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    images.forEach((src) => {
      // Check if already preloaded
      const existingLink = document.querySelector(`link[href="${src}"]`);
      if (existingLink) return;

      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = src;
      
      if (priority) {
        link.setAttribute("fetchpriority", "high");
      }

      document.head.appendChild(link);
    });
  }, [images, priority]);
};

/**
 * Preload a single critical image (like hero/LCP image)
 */
export const preloadCriticalImage = (src: string) => {
  if (typeof window === "undefined") return;
  
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = src;
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
};

export default usePreloadImages;
